

export const PRODUCTIVITY_DESC = "Biomass indicates vegetative vigor on a specific date, with 100 being dense green vegetation and 0 being little to no vegetation present.";
export const STRESS_DESC = "Stress indicates the loss of chlorophyl, with 0 being no vegetative stress, and 100 being a complete loss of green pigments.";